/* src/app/modules/spare-parts/spare-parts-tabs/spare-parts-tabs.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=spare-parts-tabs.component.css.map */
